/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import ReactPagination from 'react-js-pagination';
import { useSelector, useDispatch } from 'react-redux';
import { DateTime } from 'luxon';

// actions
import { loadAgents } from '../../actions/agent';

// components
import { ModalBase } from '../../common/components';

function LeadDetailsModal() {
  const dispatch = useDispatch();

  const { leadDetails = {} } = useSelector(store => store.leads);
  const { leadDetailsModal: modalOpen } = useSelector(store => store.modals);
  const { leadDetailsModalFieldConfig } = useSelector(store => store.theme);

  function closeModalAction() {
    dispatch({ type: 'CLOSE_MODAL', modal: 'leadDetailsModal' });
  }

  // if this is specified in the theme config use that; otherwise use default here
  const displayFields = (leadDetailsModalFieldConfig || [
    { name: 'Lead ID', field: 'lead_id', type: 'string' },
    { name: 'First Name', field: 'first_name', type: 'string' },
    { name: 'Last Name', field: 'last_name', type: 'string' },
    { name: 'Lead Type', field: 'lead_type', type: 'string' },
    { name: 'Lead Source', field: 'lead_source', type: 'string' },
    { name: 'Address', field: 'address', type: 'string' },
    { name: 'City', field: 'city', type: 'string' },
    { name: 'State', field: 'state', type: 'capitalize' },
    { name: 'Zipcode', field: 'zip', type: 'string' },
    { name: 'County FIPS', field: 'county', type: 'string' },
    { name: 'County Name', field: 'county_name', type: 'string' },
    { name: 'Created', field: 'created', type: 'date' },
    { name: 'Last Updated', field: 'last_updated', type: 'date' },
    { name: 'Lead Opened', field: 'lead_opened', type: 'boolean' },
    { name: 'SOA Count', field: 'soa_count', type: 'count' },
    { name: 'Enrollment Count', field: 'enrollment_count', type: 'count' },
  ]);

  function formatter(value, type) {
    let formatted = String(value);

    if (type === 'string') {
      formatted = (value || '');
    } else if (type === 'capitalize') {
      formatted = formatted.toUpperCase();
    } else if (type === 'boolean') {
      formatted = String(value);
    } else if (type === 'date') {
      formatted = DateTime.fromISO(value).toISODate();
    } else if (type === 'count') {
      formatted = value ? String(value) : '0';
    }
    return formatted;
  }

  return (
    <ModalBase
      isOpen={modalOpen}
      closeModalAction={() => closeModalAction()}
      staticWidth="700px"
    >
      <h3 className="mb-4">Lead Details</h3>

      <table className="table table-striped-columns">
        <tbody>
          {displayFields.map(field => (
            <tr>
              <td><b>{field.name}</b></td>
              <td>{formatter(leadDetails[field.field], field.type)}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </ModalBase>
  );
}

export default LeadDetailsModal;
